<template>
  <div class="insurance-list-container">
    <div class="card-container">
      <!-- 查询区域 -->
      <div class="query-section">
        <!-- 保单号 -->
        <div class="query-item">
          <span class="query-label">保单号</span>
          <el-input
            v-model="policyNo"
            placeholder="请输入保单号"
            style="width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 产品名称 -->
        <div class="query-item">
          <span class="query-label">产品名称</span>
          <el-select
            v-model="selectedProductId"
            placeholder="请选择产品"
            style="width: 200px;"
            clearable
          >
            <el-option label="全部产品" value=""></el-option>
<!--            <el-option label="安得智联供方人员意外险方案" value="1948587488204410881"></el-option>-->
<!--            <el-option label="安得智联供方人员意外险补充保额方案" value="1948587557053911042"></el-option>-->
            <el-option label="安得智联供方人员意外险方案" value="1948587609948278786"></el-option>
            <el-option label="安得智联供方人员意外险补充保额方案" value="1948587670757298177"></el-option>
          </el-select>
        </div>

        <!-- 投保单号 -->
        <div class="query-item">
          <span class="query-label">投保单号</span>
          <el-input
            v-model="insuredNo"
            placeholder="请输入投保单号"
            style="width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 状态 -->
        <div class="query-item">
          <span class="query-label">状态</span>
          <el-select
            v-model="policyStatus"
            placeholder="请选择状态"
            style="width: 200px;"
            clearable
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="已出单" value="00"></el-option>
            <el-option label="保障中" value="01"></el-option>
            <el-option label="已过期" value="02"></el-option>
            <el-option label="已撤单" value="03"></el-option>
          </el-select>
        </div>

        <!-- 投保人 -->
        <div class="query-item">
          <span class="query-label">投保人名称</span>
          <el-input
            v-model="appliRealName"
            placeholder="请输入投保人"
            style="width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 出单时间 -->
        <div class="query-item">
          <span class="query-label">出单时间</span>
          <el-date-picker
            v-model="orderTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 280px;"
            clearable
          >
          </el-date-picker>
        </div>

        <!-- 生效时间 -->
        <!--        <div class="query-item">-->
        <!--          <span class="query-label">生效时间</span>-->
        <!--          <el-date-picker-->
        <!--            v-model="effectTimeRange"-->
        <!--            type="daterange"-->
        <!--            range-separator="至"-->
        <!--            start-placeholder="开始日期"-->
        <!--            end-placeholder="结束日期"-->
        <!--            format="yyyy-MM-dd"-->
        <!--            value-format="yyyy-MM-dd"-->
        <!--            style="width: 280px;"-->
        <!--            clearable-->
        <!--          >-->
        <!--          </el-date-picker>-->
        <!--        </div>-->

        <!-- 状态 -->
        <!--        <div class="query-item">-->
        <!--          <span class="query-label">状态</span>-->
        <!--          <el-select-->
        <!--            v-model="policyStatus"-->
        <!--            placeholder="请选择状态"-->
        <!--            style="width: 200px;"-->
        <!--            clearable-->
        <!--          >-->
        <!--            <el-option label="全部状态" value=""></el-option>-->
        <!--            <el-option label="生效" value="1"></el-option>-->
        <!--            <el-option label="失效" value="0"></el-option>-->
        <!--            <el-option label="暂停" value="2"></el-option>-->
        <!--          </el-select>-->
        <!--        </div>-->

        <div class="query-buttons">
          <el-button type="primary" @click="fetchInsuranceList" class="query-button">查询</el-button>
          <el-button type="default" @click="resetQuery" class="reset-button">重置</el-button>
        </div>
      </div>

      <!-- 列表区域：添加滚动容器 -->
      <div class="table-scroll-container">
        <el-table
          :data="insuranceList"
          border
          style="width: 100%;"
          v-loading="loading"
          :loading-text="'正在加载数据...'"
          class="insurance-table"
        >
          <!-- 所有列保持不变 -->
          <el-table-column prop="productName" width="300" label="产品名称"></el-table-column>
          <el-table-column prop="insuredNo" width="250" label="投保单号"></el-table-column>
          <el-table-column prop="policyNo" width="250" label="保单号"></el-table-column>
          <el-table-column prop="premiumPrice" width="120" label="保费"></el-table-column>
          <el-table-column prop="appliRealName" width="250" label="投保人名称"></el-table-column>
          <el-table-column prop="orderTime" width="200" label="出单时间"></el-table-column>
          <el-table-column prop="policyStatus" width="200" label="保单状态"></el-table-column>
          <el-table-column prop="effectiveBeginTime" width="150" label="保单生效日期"></el-table-column>
          <el-table-column prop="effectiveEndTime" width="150" label="保单结束时间"></el-table-column>
          <!--          <el-table-column prop="policyStatus_dictText" label="状态"></el-table-column>-->
          <!--          <el-table-column prop="epolicyFileUrl" label="电子保单">-->
          <!--            <template slot-scope="scope">-->
          <!--              <a :href="scope.row.epolicyFileUrl" download class="download-link">下载保单</a>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="epolicyFileUrl" label="投保确认书">-->
          <!--            <template slot-scope="scope">-->
          <!--              <a :href="scope.row.epolicyFileUrl" download class="download-link">下载确认书</a>-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <!-- 添加操作列 -->
          <!-- 操作列 -->
          <el-table-column label="操作" width="250" fixed="right">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <!-- 下载电子保单 -->
                <a
                  :href="scope.row.epolicyFileUrl"
                  target="_blank"
                  class="download-link"
                  v-if="scope.row.epolicyFileUrl"
                >
                  下载电子保单
                </a>

                <!-- 下载投保确认书 -->
                <!--                <a
                  :href="scope.row.epolicyFileUrl"
                  download
                  class="download-link"
                  v-if="scope.row.epolicyFileUrl"
                >
                  下载确认书
                </a>
                -->

                <!-- 批改按钮 -->
                <el-button
                  v-if="shouldShowModifyButton(scope.row.effectiveEndTime)"
                  type="text"
                  size="small"
                  class="modify-button"
                  @click="handleModify(scope.row)"
                >
                  新增保全
                </el-button>

                <!-- 导出按钮放入更多下拉菜单 -->
                <el-dropdown trigger="hover">
                  <span class="el-dropdown-link" style="color: #409EFF;">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="exportInsuredEmployeeList(scope.row)">
                      导出在保雇员清单
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="exportHistoricalEmployeeList(scope.row)">
                      导出历史投保雇员清单
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {service, ApiRoot} from '../../utils/axios'
import {getToken} from '../../utils/auth'

export default {
  name: 'policyList',
  data () {
    return {
      policyNo: '',
      selectedProductId: '',
      policyStatus: '',
      insuredNo: '',
      appliRealName: '',
      orderTimeRange: [],
      // effectTimeRange: [],
      // policyStatus: '',
      loading: false,
      insuranceList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    async fetchInsuranceList () {
      this.loading = true
      try {
        const params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          productId: this.selectedProductId ? [this.selectedProductId] : ['1948587670757298177', '1948587609948278786'],
          policyNo: this.policyNo,
          insuredNo: this.insuredNo,
          appliRealName: this.appliRealName,
          policyStatus: this.policyStatus,
          orderTime_begin: this.orderTimeRange && this.orderTimeRange.length > 0 ? this.orderTimeRange[0] : '',
          orderTime_end: this.orderTimeRange && this.orderTimeRange.length > 0 ? this.orderTimeRange[1] : ''
          // effectTime_begin: this.effectTimeRange && this.effectTimeRange.length > 0 ? this.effectTimeRange[0] : '',
          // effectTime_end: this.effectTimeRange && this.effectTimeRange.length > 0 ? this.effectTimeRange[1] : '',
          // policyStatus: this.policyStatus
        }
        const res = await service.get('/policy/insurancePolicy/list', {
          params: params,
          headers: {'x-access-token': getToken() || ''},
          timeout: 100000
        })
        if (res.success) {
          this.insuranceList = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error('数据获取失败')
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$message.error('登录过期，请重新登录')
          this.$router.push({path: '/login'})
        }
        console.error('接口请求异常:', error)
        this.$message.error('数据加载失败')
      } finally {
        this.loading = false
      }
    },
    // 添加批改按钮显示控制方法
    shouldShowModifyButton (effectiveEndTime) {
      if (!effectiveEndTime) return false
      // 将日期字符串转换为Date对象
      const currentDate = new Date()
      const endDate = new Date(effectiveEndTime)
      // 比较当前日期是否在结束日期之前
      return currentDate < endDate
    },
    // 添加批改按钮点击事件
    handleModify (row) {
      // 这里可以添加批改逻辑，例如跳转到批改页面
      this.$router.push({
        path: '/SidebarMenu/modifyPolicy',
        query: {
          productId: row.productId,
          policyNo: row.policyNo,
          productName: row.productName
        }
      })
    },
    // 导出在保雇员清单
    async exportInsuredEmployeeList (row) {
      if (!row || !row.id) {
        this.$message.error('无效的保单信息')
        return
      }

      this.loading = true
      try {
        // 注意：由于axios响应拦截器会直接返回response.data，
        // 但我们需要完整的response对象来处理blob，所以使用原生fetch
        const token = getToken() || ''
        // 从axios.js中获取基础URL
        const url = `${ApiRoot}/andeEIC/eicAccidentInsurance/exportInsuredEmployeeList`

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'x-access-token': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({id: row.id})
        })

        // 检查响应是否成功
        if (!response.ok) {
          throw new Error('请求失败，状态码: ' + response.status)
        }

        // 直接获取blob数据
        const blobData = await response.blob()

        // 检查文件是否为空（小于1KB通常表示没有实际数据）
        if (blobData.size < 1024) {
          this.$message.warning('没有数据可导出')
          return
        }

        // 处理文件下载
        const fileName = `${row.policyNo}_在保雇员清单_${new Date().getTime()}.xls`

        // 创建下载链接
        const urlBlob = window.URL.createObjectURL(blobData)
        const link = document.createElement('a')
        link.href = urlBlob
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        // 清理资源
        document.body.removeChild(link)
        window.URL.revokeObjectURL(urlBlob)

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 导出历史投保雇员清单
    async exportHistoricalEmployeeList (row) {
      if (!row || !row.id) {
        this.$message.error('无效的保单信息')
        return
      }

      this.loading = true
      try {
        // 使用与在保雇员清单相同的方式，但调用不同的接口
        const token = getToken() || ''
        const url = `${ApiRoot}/andeEIC/eicAccidentInsurance/exportHistoricalEmployeeList`

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'x-access-token': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({id: row.id})
        })

        // 检查响应是否成功
        if (!response.ok) {
          throw new Error('请求失败，状态码: ' + response.status)
        }

        // 直接获取blob数据
        const blobData = await response.blob()

        // 检查文件是否为空（小于1KB通常表示没有实际数据）
        if (blobData.size < 1024) {
          this.$message.warning('没有数据可导出')
          return
        }

        // 处理文件下载，使用不同的文件名
        const fileName = `${row.policyNo}_历史投保雇员清单_${new Date().getTime()}.xls`

        // 创建下载链接
        const urlBlob = window.URL.createObjectURL(blobData)
        const link = document.createElement('a')
        link.href = urlBlob
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        // 清理资源
        document.body.removeChild(link)
        window.URL.revokeObjectURL(urlBlob)

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.fetchInsuranceList()
    }, // 新增重置方法
    resetQuery () {
      this.policyNo = ''
      this.insuredNo = ''
      this.appliRealName = ''
      this.orderTimeRange = []
      this.policyStatus = ''
      this.currentPage = 1
      this.fetchInsuranceList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchInsuranceList()
    }
  },
  created () {
    this.fetchInsuranceList()
  }
}
</script>

<style scoped>
.insurance-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.card-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.query-button {
  height: 40px;
}

/* 表头样式 */
::v-deep .insurance-table .el-table__header th {
  white-space: nowrap !important;
  background-color: #f5f7fa;
  font-weight: 500;
}

/* 行hover样式 */
::v-deep .insurance-table .el-table__row:hover {
  background-color: #f5f7fa;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.download-link {
  color: #409EFF;
  text-decoration: none;
}

.query-section {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  padding: 15px;
  background-color: #f9fafc;
  border-radius: 6px;
}

.query-item {
  display: flex;
  align-items: center;
}

.query-label {
  width: 80px;
  text-align: right;
  margin-right: 8px;
  color: #606266;
  font-size: 14px;
}

.query-buttons {
  margin-left: auto;
}

::v-deep .insurance-table .el-table__row:hover {
  background-color: #f5f7fa;
}

/* 增强表格滚动容器样式 */
.table-scroll-container {
  width: 100%;
  overflow-x: auto; /* 强制显示水平滚动条 */
  margin-bottom: 20px;
  /* 添加内阴影增强视觉效果 */
  box-shadow: inset 0 0 0 1px transparent;
}

/* 确保表格内容足够宽以触发滚动 */
.insurance-table {
  width: 100%;
  min-width: 1300px; /* 增加最小宽度值确保溢出 */
}

/* 优化滚动条样式 */
.table-scroll-container::-webkit-scrollbar {
  height: 10px;
}

.table-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.table-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* 确保表格单元格内容不换行 */
::v-deep .insurance-table .el-table__cell {
  white-space: nowrap !important;
}

.operation-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
  white-space: nowrap; /* 防止按钮换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 溢出时显示省略号 */
}

/* 调整操作列单元格样式 */
::v-deep .el-table .el-table__cell:last-child {
  padding: 0 10px;
}

/* 导出按钮样式 */
.export-button {
  color: #409EFF;
}

</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/policyList.vue